import $console from '@zuto/utilities/src/$console'
import ZutoAnalyticsHelper from '@zuto-internal/zuto-analytics-helper'

const zutoAnalyticsHelper = new ZutoAnalyticsHelper()

export type CSPReportData = {
  'csp-report': {
    blockedURI?: string
    documentURI?: string
    referrer?: string
    violatedDirective?: string
    originalPolicy?: string
  }
}

type CSPViolationError = {
  eventType?: string
  message?: string
}

export const fireClientSideKibanaLog = (additionalProperties?: Record<string, string | undefined>) => {
    zutoAnalyticsHelper.sendCustomEvent({
        eventType: 'App-Form CSP violation report',
        eventCategory: 'CSP violation report',
        eventMessage: 'CSP violation reported successfully',
        eventLevel: 'Info',
        ...additionalProperties
    })
}

export const reportCSPViolation = async (report: CSPReportData) => {
    const { blockedURI, documentURI, referrer, violatedDirective } = report['csp-report']
    try {
        fireClientSideKibanaLog({
            eventBlockedUri: blockedURI,
            eventDocumentUri: documentURI,
            eventReferrer: referrer,
            eventViolatedDirective: violatedDirective
        })
    } catch (error: unknown) {
        const typedError = error as CSPViolationError
        $console.error(`unable to send ${typedError?.eventType}, event: ${typedError?.message}`)
        $console.error('zutoAnalyticsHelper.sendCustomEvent error', error)
    }
}

export const handleCSPViolation = (e: SecurityPolicyViolationEvent) => {
  reportCSPViolation({
    'csp-report': {
      documentURI: e.documentURI,
      referrer: e.referrer,
      blockedURI: e.blockedURI,
      violatedDirective: e.violatedDirective,
      originalPolicy: e.originalPolicy
    }
  })
}